export default __webpack_public_path__ + "static/media/frame8.bf53d02b.jpg";